import Button from '@repo/ui/button'
import { PrintIcon } from '@repo/ui/icons'
import { useState } from 'react'

import { API, constructApiUrl } from '../../../api/apis.config'
import { useDownloadDocuments } from '../../../lib/hooks/use-download-documents'

type Props = {
  id: number
  onSuccess?: () => void
}

const BudgetAllocationGenerateReceiptButton = ({ id, onSuccess }: Props) => {
  const [loading, setLoading] = useState(false)
  const { downloadDocuments } = useDownloadDocuments()

  return (
    <Button
      variant="ghost"
      icon={PrintIcon}
      loading={loading}
      label="Imprimer reçu"
      onClick={async () => {
        setLoading(true)
        await downloadDocuments({
          endpoint: constructApiUrl(API.budgetAllocation.generateBudgetAllocationReceipt.url, {
            id
          })
        })
        setLoading(false)
        onSuccess?.()
      }}
    />
  )
}

export default BudgetAllocationGenerateReceiptButton
